import {  HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, Subject, switchMap, throwError } from 'rxjs';
import { ProblemDetails } from '../models/problem-details';
import { MessageService } from '../services/message.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private messageService: MessageService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> | any {
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (error?.status) {
          switch (error.status) {
            case 400:
            case 403:
            case 404:
            case 405:
            case 409:
            case 500:
              if (error.error?.detail || error.error?.title) {
                const problemDetails = error.error as ProblemDetails;

                this.showProblemDetailsErrorMessage(problemDetails);
              }
              else if (error.error?.size) {
                return this.parseErrorBlob(error).pipe(
                  switchMap(problemDetails => {
                    this.showProblemDetailsErrorMessage(problemDetails);  
  
                    return throwError(() => problemDetails.title);
                  })
                );
              }
              else {
                this.messageService.openErrorTranslation('Messages.UnexpectedError');
              }
              break;
          }
        }
        else {
          this.messageService.openErrorTranslation('Messages.UnexpectedError');
        }

        return throwError(() => error);
      })
    );
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<ProblemDetails> {
    var subject = new Subject<ProblemDetails>();

    let reader = new FileReader();
    reader.onload = () => {
      subject.next(JSON.parse(reader?.result as string));
    };

    reader.readAsText(err.error);

    return subject.asObservable();
  }

  showProblemDetailsErrorMessage(problemDetails: ProblemDetails): void {
    if(problemDetails.detail){
      this.messageService.openError(problemDetails?.detail);
    }
    else if (problemDetails.title) {
      this.messageService.openError(problemDetails.title);
    } 
    else {
      this.messageService.openErrorTranslation('Messages.UnexpectedError');
    }
  }
}
